import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BuildCache = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M12 3.5C11.7474 2.09838 9.36902 1 6.5 1C3.63098 1 1.25261 2.09838 1 3.5C1 4.88071 3.46243 6 6.5 6C9.53757 6 12 4.88071 12 3.5Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M1 8V5.43822C1.3631 5.74564 1.78552 5.99105 2.19711 6.17813C3.34983 6.7021 4.87207 7 6.5 7C7.79759 7 9.02802 6.81073 10.0577 6.46858L7.09521 10.4566C7.08782 10.4665 7.08055 10.4765 7.0734 10.4866C6.88493 10.4955 6.69363 10.5 6.5 10.5C3.46243 10.5 1 9.38071 1 8ZM5 8.5C5 8.91421 4.66421 9.25 4.25 9.25C3.83579 9.25 3.5 8.91421 3.5 8.5C3.5 8.08579 3.83579 7.75 4.25 7.75C4.66421 7.75 5 8.08579 5 8.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M6.5 11.5C6.58363 11.5 6.66697 11.4992 6.75 11.4977C6.74959 11.7667 6.81114 12.0369 6.93656 12.2863C7.23371 12.8772 7.8386 13.2501 8.50001 13.2501H9.14685L9.04361 14.3342C9.03217 14.4543 9.03324 14.5733 9.04589 14.6897C8.28286 14.8879 7.41646 15 6.5 15C3.63098 15 1.25261 13.9016 1 12.5V9.93822C1.3631 10.2456 1.78552 10.491 2.19711 10.6781C3.34983 11.2021 4.87207 11.5 6.5 11.5ZM4.25 13.75C4.66421 13.75 5 13.4142 5 13C5 12.5858 4.66421 12.25 4.25 12.25C3.83579 12.25 3.5 12.5858 3.5 13C3.5 13.4142 3.83579 13.75 4.25 13.75Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M12.4834 5.79998C12.7976 5.92074 12.9928 6.23606 12.9609 6.57116L12.7534 8.75006H14.5C14.7835 8.75006 15.0427 8.90987 15.1701 9.16311C15.2974 9.41635 15.2711 9.71975 15.1021 9.9473L11.3878 14.9473C11.187 15.2175 10.8309 15.3209 10.5167 15.2001C10.2024 15.0794 10.0072 14.7641 10.0391 14.4289L10.2466 12.2501H8.5C8.21654 12.2501 7.9573 12.0902 7.82995 11.837C7.70261 11.5838 7.72891 11.2804 7.89795 11.0528L11.6122 6.05281C11.813 5.78259 12.1691 5.67922 12.4834 5.79998Z"
      fill="currentColor"
    />
  </Icon>
));

export default BuildCache;
